// extracted by mini-css-extract-plugin
module.exports = {"root":"Dropdown_root__diCSj","slideIn":"Dropdown_slideIn__2M2TZ"};